// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PlanLineSnapshot.yaml
// Generated: 2026-08-12T18:58:42.915Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { PlanLineSnapshot } from '@/types/finance/PlanLineSnapshot';

/**
 * PlanLineSnapshot Service (Read-Only)
 * Query operations for PlanLineSnapshot via the ABP API.
 */
export const planLineSnapshotService = new ReadOnlyEntityService<PlanLineSnapshot>(
  '/api/finance/planlinesnapshot',
  'PlanLineSnapshot',
);
